import { BaseDataBind } from "./base";


export class BaseEventDataBind extends BaseDataBind
{
    protected eventName: string;
    public attributeName = 'data-bind-event';
    public selector = '[data-bind-event]';
    public eventNames = [];

    protected getPropertyValue(element: Element)
    {
        let handlerName = super.getPropertyValue(element);
        if (this.eventName)
        {
            this.bindEvent(element, this.eventName, handlerName);
        }
        
        return handlerName;
    }

    protected bindEvent(element: Element, eventName: string, handlerName: string)
    {
        // Wrap so that normal methods work
        element.addEventListener(eventName, (e: Event) =>
        {
            this.view[handlerName](e, element);
        });
    }

    protected setElementValue(element: Element, value: any) {}
    protected getElementValue(element: Element) { return undefined; }
}
/**
 * Data bind type of element's event.
 * Used for binding events.
 */
export class EventDataBind extends BaseEventDataBind
{
    protected getPropertyValue(element: Element)
    {
        let value = super.getPropertyValue(element);
        let parts = value.split(':');
        
        let eventName = parts[0];
        let handlerName = parts[1];

        this.bindEvent(element, eventName, handlerName);
        return value;
    }

    protected setElementValue(element: Element, value: any) {}

    protected getElementValue(element: Element): any
    {
        return undefined;
    }
}

export class ClickEventDataBind extends BaseEventDataBind
{
    public attributeName = 'data-bind-click';
    public selector = '[data-bind-click]';
    protected eventName = 'click';

    protected setElementValue(element: Element, value: any) {}
    protected getElementValue(element: Element) { return undefined; }
}

export class SubmitEventDataBind extends BaseEventDataBind
{
    public attributeName = 'data-bind-submit';
    public selector = '[data-bind-submit]';
    protected eventName = 'submit';

    protected setElementValue(element: Element, value: any) {}
    protected getElementValue(element: Element) { return undefined; }
}